<template>
  <div :class="classes" v-loading="loading">
    <wt-re-request-tip message="检测项文本信息获取失败" :reLoad="load" v-show="loadFailed">
		</wt-re-request-tip>
     <pt-page-title title="编辑检测项知识库"></pt-page-title>
    <data-entry-form v-model="corpus" ref="child" v-if="corpus"></data-entry-form>
    <div class="marginTop">
    <el-button type="primary" @click="edit">保存</el-button>
		<el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
// 组件class前缀
import dataEntryForm from 'cps/gene-product/data-entry-form/index'
const prefixCls = 'pt-detection-corpus-update'

export default {
  name: 'pt-detection-corpus-update',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    dataEntryForm
  },
  data () {
    return {
      id: this.$route.params.id,
      // 用于绑定的产品数据对象
      corpus: this.$route.params.value ? this.$route.params.value : null,
      // 页面是否在进行数据loading
      loading: false,
      // 是否加载失败，用于显示遮罩层，用户可触发重试
      loadFailed: false,
      isOk: true
    }
  },
  methods: {
    confirmLastNode (form) {
      this.isOk = true
      if (!form.contents) {
        if (!form.header) {
          this.isOk = false
          this.$message.warning('请将标题填写完整！')
        }
      } else {
        let num = form.contents.length
        if (!num) {
          if (!form.header) {
            console.log('lastForm', form)
            this.isOk = false
            this.$message.warning('请将标题填写完整！')
          }
        } else {
          this.confirmLastNode(form.contents[num - 1])
        }
      }
    },
    // 加载详情数据
    load () {
      this.loading = true
      this.loadFailed = false

      this.$store.dispatch('getDetectionCorpus', this.id).then((response) => {
        this.loadFailed = false
        this.loading = false
        console.log('response.data', response.data)
        this.corpus = response.data
      }).catch((error) => {
        this.loading = false
        this.loadFailed = true
        this.$message.error(error)
      })
    },
    updateCorpus (form) {
      var arr
      if (form.inlineForm) {
        arr = Object.keys(form.inlineForm)
        if (arr.length) {
          arr.forEach(ele => {
            form[ele] = form.inlineForm[ele]
          })
        }
      }
      console.log('form', form)
      // 判断是否最后一条记录是否填写
      this.confirmLastNode(form)
      if (this.isOk) {
        this.loading = true
        this.$store.dispatch('updateDetectionCorpus', form).then((response) => {
          this.$message.success('修改成功!')
          this.loading = false
          history.go(-1)
        }).catch((error) => {
          console.error(error)
          this.$message.error(error)
          this.loading = false
        })
      }
    },
    checkRepeat (form) {
      return this.$store.dispatch('getDetectionCorpusBycorpusAndName', form).then(data => {
        return data
      }).catch(err => {
        return err
      })
    },
    async createdCorpus (form) {
      var arr
      if (form.inlineForm) {
        arr = Object.keys(form.inlineForm)
        if (arr.length) {
          arr.forEach(ele => {
            form[ele] = form.inlineForm[ele]
          })
        }
      }
      console.log('form', form)
      // 判断是否最后一条记录是否填写
      this.confirmLastNode(form)
      console.log('form', form)
      if (this.isOk) {
        this.loading = true
        let checkRes = await this.checkRepeat(form)
        console.log('checkRes', checkRes)
        if (!checkRes.id) {
          this.updateCorpus(form)
        } else {
          this.loading = false
          // this.$confirm(`已存在所属知识库为"${checkRes.corpusName}",知识库名称为“${checkRes.chineseName}”的知识库 是否覆盖原内容?`, '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   type: 'warning'
          // }).then(() => {
          this.updateCorpus(form)
          // }).catch(() => {
          //   this.$message({
          //     type: 'info',
          //     message: '已取消覆盖'
          //   })
          // })
        }
      }
    },
    edit () {
      var _this = this
      var arr = this.$refs.child.formValidate()
      Promise.all(arr).then(function () { // 都通过了
        _this.createdCorpus(_this.corpus)
        // _this.updateCorpus(_this.corpus)
        // alert('恭喜你，表单全部验证通过啦')
      }).catch(function () {
        console.log('err')
      })
    },
    cancel () {
      history.go(-1)
    }
  },
  created () {
    // 如果父组件没有传入产品数据，则本页面根据id进行获取
    this.id = this.$route.params.id
    if (!this.corpus) {
      this.load()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
